const environment = {
  env: "preprod",
};

export default environment;
